import { jsx, Fragment } from 'react/jsx-runtime';
import { useSwitch } from '../../Switch.hooks.js';
import { Label } from '../Label/Label.js';

function Slot(props) {
  const {
    id,
    size,
    slotCount
  } = useSwitch();
  const {
    as
  } = props;
  if (as === 'node') {
    const {
      checked
    } = props;
    return jsx(Fragment, {
      children: props.children({
        checked,
        id,
        size,
        slotCount
      })
    });
  }
  const {
    checked,
    children
  } = props;
  // When using just one slot, no matter the direction of it, the label will always be considered as truthy
  // to avoid it being grayed out.
  return jsx(Label, {
    asChild: as === 'text',
    checked: slotCount === 1 ? true : checked,
    id: as === 'label' ? id : undefined,
    size: size,
    children: children
  });
}

export { Slot };
